// Module-level store so upload progress survives the UploadPdf component
// unmounting/remounting when the user switches tabs/pages and comes back.
let state = {
  file: null,
  loading: false,
  message: "",
  noticeType: "success",
  error: "",
};

const listeners = new Set();

const setState = (partial) => {
  state = { ...state, ...partial };
  listeners.forEach((listener) => listener());
};

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const getSnapshot = () => state;

export const uploadPdfStore = { setState, subscribe, getSnapshot };
